<template>
    <div>
        <Head :title="`${form.name}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/traffic-sources">Traffic sources</Link>
                <span class="text-indigo-400 font-medium">/</span>
                {{ form.name }}
            </h1>
        </div>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden mb-5">
            <div class="w-full">
                <h3 class="font-medium text-gray-900 text-center mt-5 px-6">List of traffic source assets</h3>
                <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                    <table class="w-full whitespace-nowrap">
                        <tr class="text-left font-bold">
                            <th class="pb-4 pt-6 px-6">Preview</th>
                            <th class="pb-4 pt-6 px-6">Link</th>
                        </tr>
                        <tr v-for="asset in trafficSourceResources" :key="asset.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                            <td class="border-t">
                                <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                    <img :src="asset.link" style="width: 200px">
                                </div>
                            </td>
                            <td class="border-t">
                                {{asset.link}}
                            </td>
                        </tr>
                        <tr v-if="trafficSourceResources.length === 0">
                            <td class="px-6 py-4 border-t" colspan="5">No assets found.</td>
                        </tr>
                    </table>
                </div>
                <form @submit.prevent="uploadAsset">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <file-input v-model="asset.asset" class="pb-8 pr-6 w-full w-full" type="file"/>
                    </div>
                    <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                        <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Upload asset</loading-button>
                    </div>
                </form>
            </div>
        </div>
        <div class="w-full bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Traffic source name"/>
                    <select-input v-model="form.brand_id" :error="form.errors.brand_id"
                                  class="pb-8 pr-6 w-full lg:w-1/2" label="Brand">
                        <option v-for="(id, name) in brands" :value="id">{{ name }}</option>
                    </select-input>
                    <label class="pb-8 pr-6 w-full lg:w-full" for="remember">
                        <input id="remember" v-model="form.is_default" class="mr-1" type="checkbox" />
                        <span class="text-sm">is default traffic source</span>
                    </label>
                    <h5>Translations</h5>
                    <Vue3JsonEditor
                        v-model="form.translations"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeTranslations"/>
                    <h5>Config</h5>
                    <Vue3JsonEditor
                        v-model="form.config"
                        :show-btns="false"
                        :expandedOnStart="true"
                        style="width: 100%"
                        @json-change="onChangeConfig"/>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update traffic source
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import TextareaInput from "@/Shared/TextareaInput";

import {Vue3JsonEditor} from 'vue3-json-editor'
import CheckboxInput from "@/Shared/CheckboxInput";


export default {
    components: {
        CheckboxInput,
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        MultipleSelectInput,
        TextareaInput,
        Vue3JsonEditor
    },
    layout: Layout,
    props: {
        brands: Object,
        trafficSourceResources: Array,
        trafficSource: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.trafficSource.name,
                brand_id: this.trafficSource.brand_id,
                is_default: this.trafficSource.is_default,
                config: this.trafficSource.config,
                translations: this.trafficSource.translations,
            }),

            asset: this.$inertia.form({
                traffic_source_id: this.trafficSource.id,
                brand_id: this.trafficSource.brand_id,
                asset: null,
            })
        }
    },
    methods: {
        update() {
            this.form.post(`/traffic-sources/${this.trafficSource.id}`)
        },
        onChangeTranslations(value) {
            this.form.translations = value;
        },
        onChangeConfig(value) {
            this.form.config = value;
        },
        uploadAsset() {
            this.asset.post('/traffic-sources/upload-asset', {
                onSuccess: () => this.form.reset('asset'),
            })
        }
    },
}
</script>
